import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SwalService } from '../utls/swal.service';

interface CartItem {
  _id: string;
  name: string;
  description: string;
  provider: string;
  price: number;
  previousPrice: number;
  quantity: number;
  color?: string;
  colorId?: string;
  size?: string;
  sizeId?: string;
  image: string;
  maxQuantity: number;
  variableId: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private cartItems: CartItem[] = [];
  private totalItemsSubject = new BehaviorSubject<number>(0);
  private showCart: boolean = false;

  totalItems$ = this.totalItemsSubject.asObservable();

  constructor(    
    public swalService: SwalService
  ) {
    this.loadCartFromStorage();
  }

  public loadCartFromStorage(): void {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      const { cartItems, totalItems } = JSON.parse(storedCart);
      this.cartItems = cartItems;
      this.totalItemsSubject.next(this.calculateTotalItems());
    }
  }
  clearCart(): void {
    this.cartItems = [];
    localStorage.removeItem('cart');
    this.totalItemsSubject.next(0); // Correcto: usa totalItemsSubject.next()
    this.saveCartToStorage(); // Guardar el carrito luego de limpiarlo
  }
  public saveCartToStorage(): void {
    const cartData = { cartItems: this.cartItems, totalItems: this.totalItemsSubject.value };
    localStorage.setItem('cart', JSON.stringify(cartData));
  }
  addToCart(
    product: any,
    color?: any,
    size?: any,
    quantity: number = 1,
    maxQuantity: number = 1,
    typeProduct: string = 'Simple',
    variableId: string = ''): void {
    let newItem: CartItem = { 
      _id: product._id,
      name: product.name,
      description: product.description,
      price: product?.discountPrice ? product.discountPrice : product.price,
      previousPrice: product?.discountPrice ? product.price : 0,
      provider: product.providerId?.name || product.providerName,
      quantity: quantity,
      image: product.photos[0], // Usamos la primera imagen como predeterminado
      color: color,
      size: size,
      maxQuantity: maxQuantity,
      variableId: variableId
    };

    let existingItem = null;

    if (typeProduct === 'Variable') {
      existingItem = this.cartItems?.find(item =>
        item._id === newItem._id &&
        (newItem.color ? item.color === newItem.color : true) &&
        (newItem.size ? item.size === newItem.size : true)
      );
    }
    else{
      existingItem = this.cartItems?.find(item =>
        item._id === newItem._id &&
        (newItem.color ? item.color === newItem.color : true)
      );
    }

    if (existingItem) {
      existingItem.quantity += quantity;
      if(existingItem.quantity > existingItem.maxQuantity){
        existingItem.quantity = existingItem.maxQuantity;
      }
    } else {
      if (!this.cartItems){
        this.cartItems = [];
      }
      this.cartItems.push(newItem);
    }

    this.totalItemsSubject.next(this.calculateTotalItems());
    this.saveCartToStorage();
  }


  /*addToCart(product: any, color?: any, size?: any, quantity: number = 1): void {
    let newItem: CartItem = { 
      _id: product._id,
      name: product.name,
      description: product.description,
      price: product.price,
      quantity: quantity,
      image: product.photos[0] // Usamos la primera imagen como predeterminado
    };

    if (product.type_product?.toLowerCase() === 'variable' && color && size) {
      newItem.color = color.color;
      newItem.colorId = color._id;
      newItem.size = size.size;
      newItem.sizeId = size._id;
    }

    const existingItem = this.cartItems?.find(item =>
      item._id === newItem._id &&
      (newItem.colorId ? item.colorId === newItem.colorId : true) &&
      (newItem.sizeId ? item.sizeId === newItem.sizeId : true)
    );

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      if (!this.cartItems){
        this.cartItems = [];
      }
      this.cartItems.push(newItem);
    }

    this.totalItemsSubject.next(this.calculateTotalItems());
    this.saveCartToStorage();
  }*/
  addOrderDetailsToCart(orderDetails: any[]): void {
    orderDetails.forEach(orderDetail => {
      let product = orderDetail.dataProduct;
      const quantity = orderDetail.quantity;
      product.providerName = orderDetail.providerName || '';
      if (product.type_product?.toLowerCase() === 'variable' && orderDetail.colorId && orderDetail.sizeId) {
        const color = product.variable.find((v: any) => v._id === orderDetail.colorId);
        const size = color?.sizes.find((s: any) => s._id === orderDetail.sizeId);

        if (color && size) {
          if (size.stock >= quantity) {
            this.addToCart(product, color, size, quantity);
          } else {
            this.swalService.warning('¡Stock insuficiente!', `Stock insuficiente para ${product.name}. Stock disponible: ${size.stock}`);
          }
        }
      } else if (product.type_product?.toLowerCase() === 'simple') {
        const stock = product.variable[0].sizes[0].stock;
        if(stock >= quantity){
          this.addToCart(product, undefined, undefined, quantity);
        } else {
          this.swalService.warning('¡Stock insuficiente!', `Stock insuficiente para ${product.name}. Stock disponible: ${stock}`);
        }
      }
    });
  }

  removeFromCart(productId: any, color?: string, size?: string): void {
    let productIndex;
    let idProd = productId?._id || productId;
    if (color && size) {
      productIndex = this.cartItems.findIndex(item =>
        item._id === idProd &&
        item.color === color &&
        item.size === size
      );
    } else {
      productIndex = this.cartItems.findIndex(item => item._id === idProd);
    }
    if (productIndex !== -1) {
      this.cartItems.splice(productIndex, 1);
      this.totalItemsSubject.next(this.calculateTotalItems());
      this.saveCartToStorage();
    }
  }

  getCartItems(): CartItem[] {
    return this.cartItems;
  }

  getTotalItems(): number {
    return this.totalItemsSubject.value;
  }

  private calculateTotalItems(): number {
    return this.cartItems.length;
  }

  toggleCart(){
    this.showCart = !this.showCart;
  }

  cartOpen(){
    return this.showCart;
  }
}